import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import {Fill, Stroke, Style} from "ol/style";
import {Vector as VectorLayer} from "ol/layer";
import VectorSource from "ol/source/Vector";

const scaleBetween = (unscaledNum, minAllowed, maxAllowed, min, max) => {
    return (maxAllowed - minAllowed) * (unscaledNum - min) / (max - min) + minAllowed;
}

const configZoom = (view, zoom, center, minZoom)=>{
  const currentCenter = view.getCenter();
  const currentZoom = view.getZoom();
  if( currentZoom !== zoom || currentCenter.length !== center.length || currentCenter.some((value, index) => value !== center[index])){
    const duration = 2000

    if(minZoom){
      view.setMinZoom(minZoom);
    }

    view.animate({
      center: center,
      duration: duration
    });
    view.animate({
      zoom: zoom - 1,
      duration: duration / 2
    }, {
      zoom: zoom,
      duration: duration / 2
    });
  }
}

const getTooltipPropertiesOfLayer = (propertiesLayer) => {
  const keys = propertiesLayer.tooltip_params.KEYS;
  const format = propertiesLayer.tooltip_params.FORMAT;
  const icon_params = propertiesLayer.tooltip_params.icon_params;
  return {keys, format, icon_params};
}

const getGroupLayerByProperty = (olMap, propertyName, propertyValue)=>{
  let findGroup;
  olMap.getLayers().forEach((groupLayer) => {
    if (groupLayer.get(propertyName) === propertyValue) {
      findGroup = groupLayer;
    }
  });

  return findGroup;
}

const getSubLayerByProperty  = (olMap, propertyName, propertyValue) => {
  let sublayer;

  olMap.getLayers().array_.forEach((layerGroup)=>{
    if(layerGroup.getLayers){
      layerGroup.getLayers().array_.forEach((element) =>{
        if(propertyValue === element.get(propertyName)){
          sublayer = element;
        }
      });
    }
  });

  return sublayer;
}

const getVisibleBaseLayerByProperty = (olMap, propertyName) => {
  let baseLayerVisible;
  olMap.getLayers().array_.forEach((layerGroup)=>{
    if(layerGroup.getLayers){
      layerGroup.getLayers().array_.forEach((element) =>{
        if(element.get('type') === 'base' && element.getVisible()){
          baseLayerVisible = element.get(propertyName);
        }
      });
    }
  });

  return baseLayerVisible;
}

const setVisibleBaseLayer = (olMap, propertyName, propertyValue)=>{
  olMap.getLayers().array_.forEach((layerGroup)=>{
    if(layerGroup.getLayers){
      layerGroup.getLayers().array_.forEach((element) =>{
        if(element.get('type') === 'base'){
          const visible = propertyValue === element.get(propertyName);
           element.setVisible(visible);
        }
      });
    }
  });
}

const createHtmlElementTooltip = (keys, formatTooltip, properties) =>{
  let htmlElement = formatTooltip;
  for (const key in keys) {
    if(moment(properties[keys[key]], "YYYY-MM-DD", true).isValid()){
      properties[keys[key]] = momentTimeZone(properties[keys[key]]).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm')
    }
    htmlElement = htmlElement.replace(`{${key}}`, properties[keys[key]]);
  }

  return htmlElement;
}

function propertyValueIsObject(value){
  try{
    const object = JSON.parse(value);

    return typeof object === 'object';
  }catch(error){
    return false;
  }
}

const initHighlightStyle = (map, fillColor, strokeColor) =>{
  const highlightStyle = new Style({
    fill: new Fill({
      color: fillColor ? fillColor : 'rgba(101, 156, 213, 0.5)',
    }),
    stroke: new Stroke({
      color: strokeColor ? strokeColor : '#659CD5',
      width: 3,
    }),
  });
  let overlay = new VectorLayer({
    source: new VectorSource(),
    map: map,
    style: highlightStyle
  });
  return overlay;
}

const getTooltipPropertiesFromFeature = (keys, featureProperties) =>{
  let properties = {items:[]};
  for (const key in keys) {
    if(propertyValueIsObject(keys[key])){
      const keyObject = JSON.parse(keys[key]);
      let value = undefined;

      if(keyObject.key.includes(',')){
        value = "";
        const arrayKey = keyObject.key.split(',');
        for (const index in arrayKey) {
          if(arrayKey[index] == 'sistema' && featureProperties[arrayKey[index]] == null){
            value += 'sem sistema associado';
          }else{
            value += featureProperties[arrayKey[index]];
          }
          value += index < arrayKey.length - 1 ? ' - ' : '';
        }

      } else if(keyObject.property_child && propertyValueIsObject(featureProperties[keyObject.key])){
        if (featureProperties[keyObject.key] != null) {
          value = JSON.parse(featureProperties[keyObject.key])[keyObject.property_child];
        }
        else {
          value = undefined;
        }
      } else {
        value = featureProperties[keyObject.key];
      }

      if (value != undefined) {
        if(typeof keyObject.decimal_number != 'undefined') {
          if (keyObject.decimal_number > 0) {
            value = Number(value).toFixed(keyObject.decimal_number);
          }
          else {
            value = Number(value).toFixed();
          }
        }
        else if( typeof value === 'string' && /^\d+\.\d+$/.test(value.replace(' ', ''))) {
          value = Number(value).toFixed(2);
        }

        if(keyObject.dateFormat){
          value = momentTimeZone(value).tz('UTC').format(keyObject.dateFormat)
        }
      }
      else {
        value = "--";
      }

      if(keyObject.label){
        properties.items.push({
          label: keyObject.label,
          value: value,
          suffix: keyObject.suffix ? keyObject.suffix : '',
          icon_label: keyObject.icon_label ? keyObject.icon_label: '',
          value_function: keyObject.value_function ? keyObject.value_function: '',
        });
      }else if(keyObject.label_title || keyObject.label_title === ""){
        properties.label_title =  keyObject.label_title;
        properties.value_title = value;
      }
      else if(keyObject.label_subtitle || keyObject.label_subtitle === ""){
        properties.label_subtitle =  keyObject.label_subtitle;
        properties.value_subtitle = value;
      }
    }
  }

  return properties;
}

export {
  scaleBetween,
  configZoom,
  getTooltipPropertiesOfLayer,
  getGroupLayerByProperty,
  getSubLayerByProperty,
  getVisibleBaseLayerByProperty,
  setVisibleBaseLayer,
  createHtmlElementTooltip,
  getTooltipPropertiesFromFeature,
  initHighlightStyle,
}
